import { render, staticRenderFns } from "./ShippingAddress.vue?vue&type=template&id=bd6ab4d6&scoped=true"
import script from "./ShippingAddress.vue?vue&type=script&lang=js"
export * from "./ShippingAddress.vue?vue&type=script&lang=js"
import style0 from "./ShippingAddress.vue?vue&type=style&index=0&id=bd6ab4d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6ab4d6",
  null
  
)

export default component.exports